import {
  i
} from "./chunk.775UL347.js";

// src/components/jb-breadcrumbs/jb-breadcrumbs.css.ts
var jb_breadcrumbs_css_default = i`.sr-only{block-size:1px;border:0;clip:rect(0, 0, 0, 0);inline-size:1px;margin:-1px;overflow:hidden;padding:0;position:absolute}@media(min-width: 960px){::slotted(jb-breadcrumbs-back-link){display:none}}::slotted(jb-breadcrumbs-item){display:none}@media(min-width: 960px){::slotted(jb-breadcrumbs-item){display:unset}}::slotted(jb-breadcrumbs-item:not(:first-of-type)){--padding-left: 20px}::slotted(jb-breadcrumbs-item:not(:last-of-type)){--dot-display: inline-block}`;

export {
  jb_breadcrumbs_css_default
};
